import React, { Component } from 'react';
import UserRole from './userRole'
import EwUsers from './ewUsers'
import CreateUserResultModal from './createUserResult'
import CreateUserLog from './CreateUserLog.jsx'
import {deslectEwUser, getUsers} from '../action/userActions'

import { Form, Col, Button, Modal, Container, Card, Carousel } from 'react-bootstrap'
import { connect } from 'react-redux'
import { createUser, deleteUser, updateUser, addRole, clearRoles } from '../action/userActions'
import { clearCos } from '../action/ewCompanyActions'
import { clearGroups } from '../action/ewGroupActions'
import Slide from 'react-reveal/Slide';
import { withRouter } from 'react-router-dom'


class CreateUser extends Component {

  constructor(e) {
    super(e)
    this.state = {
		showModal: false,
      showResult: false,
      firstName: '',
      lastName: '',
      login: '',
      email: '',
      password: '',
      department: '',
      title: '',
      manager: '',
      workNumber: '',
      mobileNumber: '',
      homeNumber: '',
      faxNumber: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      zip: '',
      country: '',
      result: 'success',
      confirmModalShow: false,
      passwordReset: false,
      showRoleError: false, 
	  input : {},
	  userMode: ''
    }

    if (this.props.selectedUser) {
      this.state.login = this.props.selectedUser.login
      console.log('about to get stuff')
      Object.keys(this.state).forEach((key) => {
        if (this.props.selectedUser[key]) {
          this.state[key] = this.props.selectedUser[key]
        }
      })
    } else {
      this.props.dispatch(addRole('A'))
    }
  }

  componentDidMount() {
    if (this.props.selectedUser)
      this.setState({ ...this.props.selectedUser })
  }

  createEwUser(input) {
    return fetch("/iframeApi/createUser",
      {
        method: 'POST',
        body: JSON.stringify(input)
      })
      .then(res => res.json());
  }

  isLoginReq() {
    let loginIsReq = false

    let stateHasSA = Object.keys(this.state).find((key) => {
      return key === 'serviceAccount'
    })

    if (stateHasSA) {
      loginIsReq = this.state.serviceAccount
    } else {
      if (this.props.selectedUser) {
        let propsHasSA = Object.keys(this.props.selectedUser).find((key) => {
          return key === 'serviceAccount'
        })
        if (propsHasSA) {
          loginIsReq = this.props.selectedUser.serviceAccount
        }
      }
    }
    return loginIsReq
  }

  getSaSettings() {
    let saOptions = { hide: false, disabled: false }
    if (this.props.selectedUser) {
      if (this.props.selectedUser.serviceAccount) {
        saOptions = { hide: false, disabled: true, hideIdea: true }
      }
      else saOptions = { hide: true, disabled: true }
    }
    else saOptions = { hide: false, disabled: false }

    return saOptions
  }

  getIdeaSettings() {
    let saOptions = { hide: false, disabled: false }
    if (this.props.selectedUser) {
      if (this.props.selectedUser.idea) {
        saOptions = { hide: false, disabled: true, hideSa: true }
      }
      else saOptions = { hide: true, disabled: true }
    }
    else saOptions = { hide: false, disabled: false }

    return saOptions

  }

  render() {

    let loginIsReq = this.isLoginReq()
    let saOptions = this.getSaSettings()
    let ideaOptions = this.getIdeaSettings()


    if (ideaOptions.hideSa || this.state.idea) {
      saOptions.hide = true
    }

    if (saOptions.hideIdea || this.state.serviceAccount) {
      ideaOptions.hide = true
    }




    return (
      <div className="App">
        <Slide left opposite>

          <Container>

            <Form onSubmit={(e) => {
              e.preventDefault();
              e.stopPropagation();

              let login = this.state.login
              let email = this.state.email

              let goodRoles = true

              this.props.roles.forEach(r => {
                console.log('roole', r)
                if (!r.co || (!r.co['Public Id of Manufacturer'] && !r.co['Public Id of Distributor'])) {
                  this.setState({ showRoleError: true })
                  goodRoles = false
                } else
                  if (!r.group || !r.group.groupId) {
                    if (!this.state.serviceAccount) {
                      this.setState({ showRoleError: true })
                      goodRoles = false
                    }

                  }

              })

              if (goodRoles) {
                if (!this.props.selectedUser) {
                  let input = {
                    ...this.state,
                    password: 'TEST1@#$%',
                    roles: this.props.roles,
                    email: email,
                    login: login
                  }
                  this.setState({ showModal: true, input: input, userMode: 'create'  })
                //  this.props.dispatch(createUser(input))
                } else {
                  console.log('getting all role info', this.props.roles)

                  let input = {
                    ...this.state,
                    roles: this.props.roles,
                    mainUserId: this.props.selectedUser.userId,
                    email: email,
                    login: login
                  }
                 // this.setState({ showResult: !this.state.showResult })
                  this.setState({ showModal: true, input: input, userMode: 'update'  })

                  //this.props.dispatch(updateUser(input))
                }
              }



            }}>
              <Card>

                <Container>

                  <Carousel interval={null} indicators={false} touch={!loginIsReq} controls={!loginIsReq} keyboard={!loginIsReq}>
                    <Carousel.Item>
                      <Form.Row >
                        <Form.Group hidden={saOptions.hide} as={Col} controlId="formGridSA">
                          <Form.Check disabled={saOptions.disabled}
                            defaultChecked={this.props.selectedUser ? this.props.selectedUser['serviceAccount'] : false}
                            type="checkbox" onChange={() => {

                              this.setState({ serviceAccount: !this.state.serviceAccount })
                            }} label="Service Account" />

                        </Form.Group>

                        <Form.Group hidden={ideaOptions.hide} as={Col} controlId="formGridIdea">
                          <Form.Check disabled={ideaOptions.disabled}
                            defaultChecked={this.props.selectedUser ? this.props.selectedUser['idea'] : false}

                            type="checkbox" onChange={() => {
                              this.setState({ idea: !this.state.idea })

                              this.props.dispatch(clearCos())
                              this.props.dispatch(clearGroups())
                              this.props.dispatch(clearRoles(true))

                            }} label="IDEA Employee" />

                        </Form.Group>



                      </Form.Row>

                      <Form.Row hidden={loginIsReq}>

                        <Form.Group as={Col} controlId="formGridFirst">
                          <Form.Label>First Name</Form.Label>
                          <Form.Control required={!loginIsReq} defaultValue={this.props.selectedUser ? this.props.selectedUser['firstName'] : ''} onChange={((e) => { this.setState({ firstName: e.target.value }) })} placeholder="First Name" />
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridMiddle">
                          <Form.Label>Middle Name</Form.Label>
                          <Form.Control
                            defaultValue={this.props.selectedUser ? this.props.selectedUser['middleName'] : ''}
                            onChange={((e) => { this.setState({ middleName: e.target.value }) })} placeholder="Middle Name" />
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridLast">
                          <Form.Label>Last Name</Form.Label>
                          <Form.Control required={!loginIsReq}
                            defaultValue={this.props.selectedUser ? this.props.selectedUser['lastName'] : ''}
                            onChange={((e) => { this.setState({ lastName: e.target.value }) })} placeholder="Last Name" />
                        </Form.Group>




                      </Form.Row>
                      <Form.Row style={{ width: '75%', margin: 'auto' }}>
                        <Form.Group as={Col} controlId="formGridEmail">
                          <Form.Label>Email</Form.Label>
                          <Form.Control required disabled={this.props.selectedUser}
                            defaultValue={this.props.selectedUser ? this.props.selectedUser['email'] : ''}
                            onChange={((e) => { this.setState({ email: e.target.value }) })} type="email" placeholder="Enter email" />


                        </Form.Group>


                      </Form.Row>

                      <Form.Row style={{ width: '75%', margin: 'auto' }} hidden={!loginIsReq}>
                        <Form.Group as={Col} controlId="formGridUsernmae">
                          <Form.Label>Login</Form.Label>
                          <Form.Control required={loginIsReq} disabled={this.props.selectedUser}
                            defaultValue={this.props.selectedUser ? this.props.selectedUser['login'] : ''}
                            onChange={((e) => { this.setState({ login: e.target.value }) })} min='5' placeholder="Enter Login" />

                        </Form.Group>

                        <Form.Group hidden={!this.props.selectedUser} as={Col} controlId="resetpassword">
                          <Form.Check
                            type="checkbox" onChange={() => {
                              this.setState({ passwordReset: !this.state.passwordReset })
                            }} label="Send Password Reset Email" />

                        </Form.Group>

                      </Form.Row>


                    </Carousel.Item>
                    <Carousel.Item hidden={loginIsReq}>
                      <Form.Row hidden={loginIsReq}>

                        <Form.Group as={Col} controlId="formGridDepartment">
                          <Form.Label>Department</Form.Label>
                          <Form.Control defaultValue={this.props.selectedUser ? this.props.selectedUser['department'] : ''} onChange={((e) => { this.setState({ department: e.target.value }) })} placeholder="Department" />
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridTitle">
                          <Form.Label>Title</Form.Label>
                          <Form.Control
                            defaultValue={this.props.selectedUser ? this.props.selectedUser['title'] : ''}
                            onChange={((e) => { this.setState({ title: e.target.value }) })} placeholder="Title" />
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridManager">
                          <Form.Label>Manager</Form.Label>
                          <Form.Control
                            defaultValue={this.props.selectedUser ? this.props.selectedUser['manager'] : ''}
                            onChange={((e) => { this.setState({ manager: e.target.value }) })} placeholder="Manager" />
                        </Form.Group>

                      </Form.Row>

                      <Form.Row hidden={loginIsReq}>

                        <Form.Group as={Col} controlId="formGridHomeNumber">
                          <Form.Label>Home Number</Form.Label>
                          <Form.Control defaultValue={this.props.selectedUser ? this.props.selectedUser['homeNumber'] : ''}
                            onChange={((e) => { this.setState({ homeNumber: e.target.value }) })} placeholder="Home Number" />
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridMobileNumber">
                          <Form.Label>Mobile Number</Form.Label>
                          <Form.Control
                            defaultValue={this.props.selectedUser ? this.props.selectedUser['mobileNumber'] : ''}
                            onChange={((e) => { this.setState({ mobileNumber: e.target.value }) })} placeholder="Mobile Number" />
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridFaxNum">
                          <Form.Label>Fax Number</Form.Label>
                          <Form.Control
                            defaultValue={this.props.selectedUser ? this.props.selectedUser['faxNumber'] : ''}
                            onChange={((e) => { this.setState({ faxNumber: e.target.value }) })} placeholder="Fax Number" />
                        </Form.Group>

                      </Form.Row>

                    </Carousel.Item>

                    <Carousel.Item hidden={loginIsReq}>
                      <Form.Row hidden={loginIsReq}>
                        <Form.Group as={Col} controlId="formGridHomeAdd1">
                          <Form.Label>Address 1</Form.Label>
                          <Form.Control defaultValue={this.props.selectedUser ? this.props.selectedUser['address1'] : ''}
                            onChange={((e) => { this.setState({ address1: e.target.value }) })} placeholder="Address 1" />
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridMobileAdd2">
                          <Form.Label>Address 2</Form.Label>
                          <Form.Control
                            defaultValue={this.props.selectedUser ? this.props.selectedUser['address2'] : ''}
                            onChange={((e) => { this.setState({ address2: e.target.value }) })} placeholder="Address 2" />
                        </Form.Group>

                      </Form.Row>


                      <Form.Row hidden={loginIsReq}>




                        <Form.Group as={Col} controlId="formGridCity">
                          <Form.Label>City</Form.Label>
                          <Form.Control
                            defaultValue={this.props.selectedUser ? this.props.selectedUser['city'] : ''}
                            onChange={((e) => { this.setState({ city: e.target.value }) })} placeholder="City" />
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridState">
                          <Form.Label>State</Form.Label>
                          <Form.Control
                            defaultValue={this.props.selectedUser ? this.props.selectedUser['state'] : ''}
                            onChange={((e) => { this.setState({ state: e.target.value }) })} placeholder="State" />
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridZip">
                          <Form.Label>Postal Code</Form.Label>
                          <Form.Control
                            defaultValue={this.props.selectedUser ? this.props.selectedUser['zip'] : ''}
                            onChange={((e) => { this.setState({ zip: e.target.value }) })} placeholder="Postal Code" />
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridCountry">
                          <Form.Label>Country</Form.Label>
                          <Form.Control
                            defaultValue={this.props.selectedUser ? this.props.selectedUser['country'] : ''}
                            onChange={((e) => { this.setState({ country: e.target.value }) })} placeholder="Country" />
                        </Form.Group>

                      </Form.Row>

                    </Carousel.Item>
                  </Carousel>




                </Container>

                <UserRole idea={this.state.idea} serviceAccount={this.state.serviceAccount} />


                <Card.Footer  >
                  <Button style={{ margin: '10px' }} hidden={this.props.selectedUser} variant={this.props.sel} type="submit">
                    Create
  </Button>

                  <Button style={{ margin: '10px' }} hidden={!this.props.selectedUser} type='submit' >
                    Update
  </Button>

                  <Button style={{ margin: '10px' }} variant='danger' onClick={() => {
					                  this.setState({ showModal: true, userMode: 'delete'  })

                  }} hidden={!this.props.selectedUser}>
                    Delete
  </Button>
                </Card.Footer>
              </Card>
            </Form>

          </Container>

        </Slide>

         <CreateUserLog
        show={this.state.showModal}
        onClose={() => {
			
			this.setState({ showModal: false  })
			this.props.dispatch(deslectEwUser())
                    this.props.dispatch(getUsers())
                    this.props.history.push('/')
					
		}}
		onCancel={() => {
			
			this.setState({ showModal: false  })
		
					
		}}
        input={this.state.input}
        uploading={false}
		mode={this.state.userMode}
		selectedUser={{...this.props.selectedUser, roles: this.props.roles}}
      />

        <Modal show={this.state.confirmModalShow}>
          <Modal.Header>
            <Modal.Title>
              Delete User ?
        </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>
              Are you sure you want to delete this user ?
           </p>
            <EwUsers />

          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => { this.setState({ confirmModalShow: false }) }}>
              Cancel
          </Button>
            <Button onClick={() => {
              this.setState({ confirmModalShow: false, showResult: !this.state.showResult })
              this.props.dispatch(deleteUser({ ...this.props.selectedUser, roles: this.props.roles }))
            }} variant='danger'>
              Delete
          </Button>
          </Modal.Footer>
        </Modal>

        <Modal show={this.state.showRoleError}>
          <Modal.Header>
            Role Error
          </Modal.Header>
          <Modal.Body>
            Please select a Company and Group
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => {
              this.setState({ showRoleError: false })
            }}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>



      </div>
    );
  }
}

const mapStateToProps = state => (
  {
    selectedCo: state.acct.ewCo.selected,
    roles: state.acct.user.roles.map((r, i) => {
      return { userId: r.userId, middleName: r.middleName, login: r.login, email: r.email, type: r.type, co: state.acct.ewCo['selected' + i], group: state.acct.ewGroup['selected' + i] }
    }) || [],
    userResult: state.acct.user.createResult,
    userError: state.acct.user.error,
    selectedUser: state.acct.user.selectedUser,
    page: state.acct.user.page
  });

export default withRouter(connect(mapStateToProps)(CreateUser))
